import { Flex } from "@chakra-ui/layout";
import {
  addMonths,
  addWeeks,
  addYears,
  format,
  subMonths,
  subWeeks,
  subYears,
} from "date-fns";
import { useMemo } from "react";

type SelectDateRangeProps = {
  interval: "week" | "month" | "year";
  value?: Date;
  setValue?: (value?: Date) => void;
};

type SelectDateRangeInternProps = Pick<
  SelectDateRangeProps,
  "value" | "setValue"
>;

const SelectDateRangeYear = ({
  value,
  setValue,
}: SelectDateRangeInternProps) => {
  const valueToString = useMemo(
    () => (value ? format(value, "yyyy") : ""),
    [value]
  );
  const decrease = () => {
    if (value && setValue) {
      setValue(subYears(value, 1));
    }
  };
  const increase = () => {
    if (value && setValue) {
      setValue(addYears(value, 1));
    }
  };
  return (
    <Flex
      borderRadius="lg"
      border="solid 1px"
      borderColor="gray.300"
      alignItems="center"
      gap={2}
      px={4}
      h="40px"
    >
      <button onClick={decrease} className="cursor-pointer">
        {"<"}
      </button>
      <Flex w="50px" justifyContent="center">
        {valueToString}
      </Flex>
      <button onClick={increase}>{">"}</button>
    </Flex>
  );
};

const SelectDateRangeMonth = ({
  value,
  setValue,
}: SelectDateRangeInternProps) => {
  const valueToString = useMemo(
    () => (value ? format(value, "MM/yyyy") : ""),
    [value]
  );
  const decrease = () => {
    if (value && setValue) {
      setValue(subMonths(value, 1));
    }
  };
  const increase = () => {
    if (value && setValue) {
      setValue(addMonths(value, 1));
    }
  };
  return (
    <Flex
      borderRadius="lg"
      border="solid 1px"
      borderColor="gray.300"
      alignItems="center"
      gap={2}
      px={4}
      h="40px"
    >
      <button onClick={decrease}>{"<"}</button>
      <Flex w="70px" justifyContent="center">
        {valueToString}
      </Flex>
      <button onClick={increase}>{">"}</button>
    </Flex>
  );
};

const SelectDateRangeWeek = ({
  value,
  setValue,
}: SelectDateRangeInternProps) => {
  const valueToString = useMemo(
    () => (value ? format(value, "w/yyyy") : ""),
    [value]
  );
  const decrease = () => {
    if (value && setValue) {
      setValue(subWeeks(value, 1));
    }
  };
  const increase = () => {
    if (value && setValue) {
      setValue(addWeeks(value, 1));
    }
  };
  return (
    <Flex
      borderRadius="lg"
      border="solid 1px"
      borderColor="gray.300"
      alignItems="center"
      gap={2}
      px={4}
      h="40px"
    >
      <button onClick={decrease}>{"<"}</button>
      <Flex w="70px" justifyContent="center">
        {valueToString}
      </Flex>
      <button onClick={increase}>{">"}</button>
    </Flex>
  );
};

const SelectDateRange = ({ interval, ...props }: SelectDateRangeProps) => {
  if (interval === "week") {
    return <SelectDateRangeWeek {...props} />;
  }
  if (interval === "month") {
    return <SelectDateRangeMonth {...props} />;
  }
  if (interval === "year") {
    return <SelectDateRangeYear {...props} />;
  }
  return <></>;
};

export default SelectDateRange;
